import termsDoc from "./TERMS.md";
import privacyDoc from "./Privacy.md";

// must be url friendly values as when setting up routes
export enum DocumentPageType {
  TermsAndConditions = "terms-conditions",
  PrivacyPolicy = "privacy"
}

const getWebDomainDocument = async (type: DocumentPageType, domain: string) => {
  let documentPath;

  switch (type) {
    case DocumentPageType.PrivacyPolicy:
      documentPath = privacyDoc;
      break;
    case DocumentPageType.TermsAndConditions:
      documentPath = termsDoc;
      break;
  }
  const file = await fetch(documentPath);
  const text = await file.text();
  const parsedDoc = text.replaceAll(/{{WEB_DOMAIN}}/gi, domain);

  return parsedDoc;
};

export default getWebDomainDocument;